import React from "react";
import { useState } from "react";
import { useStateValue } from "../StateProvider";
import {
  DashboardColumn,
  DashboardContainer,
  DashboardRow,
  DashboardWrapper,
  DashboardCard,
  DashboardHeader,
  DashboardMain,
  DashboardAside,
  DashboardCards,
  AsideHeader,
  AsideWrapper,
  AsideCard,
  AsideMain,
  CardTitle,
  CardOptions,
  CardDesc,
  CardAdmin,
  AdminAvatar,
  AdminName,
  CardFooter,
  CardWrapper,
  PriorityCard,
  CardStatus,
  DottedIcon,
  DashboardTitle,
} from "./DashboardStyle";

import tempAvatar from "../../images/kartikjha.jpg";

function Dashboard() {
  const [{ user }, dispatch] = useStateValue();

  return (
    <DashboardContainer>
      <DashboardWrapper>
        <DashboardHeader>
          <h1>
            Hello, <span>{user?.displayName}</span>
          </h1>
          <DottedIcon />
        </DashboardHeader>
        <DashboardTitle>
          <h3>Issues</h3>
        </DashboardTitle>
        <DashboardMain>
          <DashboardCards>
            <DashboardRow>
              <DashboardColumn>
                <DashboardCard>
                  <CardWrapper>
                    <CardTitle>
                      <h3>Buggy Sidebar</h3>
                    </CardTitle>
                    <CardDesc>
                      <p>Sidebar does not close on click outside of it!</p>
                    </CardDesc>
                    <CardFooter>
                      <CardAdmin>
                        <AdminAvatar src={tempAvatar} />
                        <AdminName>
                          <h4>Alistair Heus</h4>
                        </AdminName>
                      </CardAdmin>
                      <CardOptions>
                        <PriorityCard color="red">High</PriorityCard>

                        <CardStatus id="status">Open</CardStatus>
                      </CardOptions>
                    </CardFooter>
                  </CardWrapper>
                </DashboardCard>
              </DashboardColumn>
              <DashboardColumn>
                <DashboardCard>
                  <CardWrapper>
                    <CardTitle>
                      <h3>Windowed borderless bug</h3>
                    </CardTitle>
                    <CardDesc>
                      <p>Loses focus on windowed borderless setting</p>
                    </CardDesc>
                    <CardFooter>
                      <CardAdmin>
                        <AdminAvatar src={tempAvatar} />
                        <AdminName>
                          <h4>Alistair Heus</h4>
                        </AdminName>
                      </CardAdmin>
                      <CardOptions>
                        <PriorityCard color="red">High</PriorityCard>

                        <CardStatus id="status">Open</CardStatus>
                      </CardOptions>
                    </CardFooter>
                  </CardWrapper>
                </DashboardCard>
              </DashboardColumn>
            </DashboardRow>

            <DashboardRow>
              <DashboardColumn>
                <DashboardCard>
                  <CardWrapper>
                    <CardTitle>
                      <h3>Mobile View Layout</h3>
                    </CardTitle>
                    <CardDesc>
                      <p>Sidebar does not close on click outside of it!</p>
                    </CardDesc>
                    <CardFooter>
                      <CardAdmin>
                        <AdminAvatar src={tempAvatar} />
                        <AdminName>
                          <h4>Alistair Heus</h4>
                        </AdminName>
                      </CardAdmin>
                      <CardOptions>
                        <PriorityCard color="purple">Medium</PriorityCard>

                        <CardStatus id="status">Open</CardStatus>
                      </CardOptions>
                    </CardFooter>
                  </CardWrapper>
                </DashboardCard>
              </DashboardColumn>
              <DashboardColumn>
                <DashboardCard>
                  <CardWrapper>
                    <CardTitle>
                      <h3>404 on new product page</h3>
                    </CardTitle>
                    <CardDesc>
                      <p>Sidebar does not close on click outside of it!</p>
                    </CardDesc>
                    <CardFooter>
                      <CardAdmin>
                        <AdminAvatar src={tempAvatar} />
                        <AdminName>
                          <h4>Alistair Heus</h4>
                        </AdminName>
                      </CardAdmin>
                      <CardOptions>
                        <PriorityCard color="green">Low</PriorityCard>

                        <CardStatus id="status">Open</CardStatus>
                      </CardOptions>
                    </CardFooter>
                  </CardWrapper>
                </DashboardCard>
              </DashboardColumn>
            </DashboardRow>
          </DashboardCards>
          <DashboardAside>
            <AsideWrapper>
              <AsideHeader>
                <h3>Other tasks!</h3>
              </AsideHeader>
              <AsideMain>
                <AsideCard>
                  <CardTitle>
                    <p>Obsidian Web-app</p>
                  </CardTitle>
                </AsideCard>
                <AsideCard>
                  <CardTitle>
                    <p>Ark-Zephyr</p>
                  </CardTitle>
                </AsideCard>
                <AsideCard>
                  <CardTitle>
                    <p>ZeBlogs redesign</p>
                  </CardTitle>
                </AsideCard>
                <AsideCard>
                  <CardTitle>
                    <p>House of Collart</p>
                  </CardTitle>
                </AsideCard>
              </AsideMain>
            </AsideWrapper>
          </DashboardAside>
        </DashboardMain>
      </DashboardWrapper>
    </DashboardContainer>
  );
}

export default Dashboard;
